var cov_d8r21zp4s = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tree/styles/index.ts",
      hash = "1290dbda0cd8a8007468dcee5cbd99edfa22b06b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tree/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var treeLess = {};
import genaration from '../../utils/classname';
export var treeClass = (cov_d8r21zp4s.s[0]++, genaration(treeLess, 'tree'));